<!-- Floating Help / Support -->
<div class="help-backdrop" *ngIf="showHelpMenu" (click)="showHelpMenu = false"></div>
<div class="help-fab-wrapper">
    <div class="help-menu" *ngIf="showHelpMenu">
        <a class="help-menu-item" href="javascript:void(0)" (click)="openHelpLink(helpLinks.manualBook)">
            <i class="fas fa-book help-menu-icon"></i>
            <span>{{ 'Manual Book' | translate }}</span>
        </a>
        <a class="help-menu-item" href="javascript:void(0)" (click)="openHelpLink(helpLinks.tos)">
            <i class="fas fa-file-contract help-menu-icon"></i>
            <span>{{ 'Terms Of Service' | translate }}</span>
        </a>
        <a class="help-menu-item" href="javascript:void(0)" (click)="openHelpLink(helpLinks.contact)">
            <i class="fab fa-whatsapp help-menu-icon" style="color: #25d366;"></i>
            <span>{{ 'Contact Support' | translate }}</span>
        </a>
    </div>
    <button type="button" class="help-fab" [class.open]="showHelpMenu" (click)="showHelpMenu = !showHelpMenu"
        [attr.aria-label]="'Bantuan' | translate">
        <i class="fas" [ngClass]="showHelpMenu ? 'fa-times' : 'fa-question'"></i>
    </button>
</div>
<footer class="footer">
    <div class="container-fluid">
        <div class="row">
            <div class="col-sm-6" style="text-align: left;">
                {{year}} © {{detailproject.titleproject}}.
            </div>
            <div class="col-sm-6">
                <div class="text-sm-right d-none d-sm-block">
                    {{detailproject.slogan}}
                </div>
            </div>
        </div>
    </div>
</footer>